import React from "react"
import styled from "styled-components"
import { theme } from "../../../theme"
import { DownloadIcon } from "../../../icons"
import { TextLink, TextDisclaimer } from "../../atoms/text"
import { ButtonText } from "../../atoms/button"

export type AttachmentInfo = {
  id: string
  name: string
  size: string
}

export type AttachmentProps = {
  attachment: AttachmentInfo
  onClick?: (info: AttachmentInfo) => void
}

export const Attachment = (props: AttachmentProps) => {
  const { attachment, onClick } = props

  const handleClick = () => {
    onClick && onClick(attachment)
  }

  return (
    <Root onClick={handleClick}>
      <AttachmentName>{attachment.name}</AttachmentName>
      <TextDisclaimer>{attachment.size}</TextDisclaimer>
      <ButtonText icon={<DownloadIcon />} />
    </Root>
  )
}

const Root = styled.div`
  border: 1px dashed ${theme.color.grey3};
  border-radius: ${theme.borderRadius};
  padding: ${theme.spacing.m} ${theme.spacing.m} ${theme.spacing.m} ${theme.spacing.l};
  display: grid;
  grid-template-columns: auto max-content max-content;
  align-items: center;
  grid-gap: ${theme.spacing.m};
  background-color: ${theme.color.white2};
  cursor: pointer;
`

const AttachmentName = styled(TextLink)`
  width: fit-content;
  word-break: break-word;
`
